export default {
  title: 'You are not connected to the network ...',
  text: 'This device is not online. Try connecting to wifi or get better coverage.',
  reloadPageButton: 'Reload this Page'
}